import { useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { IncrementItems, DecrementItems } from "../store/CartSlicer"
import { Link } from "react-router"

function getItemPrice(item){
    const paise = "defaultPrice" in item ? item.defaultPrice : item.price;
    return (paise || 0) / 100;
}

export default function Checkout(){

    const items = useSelector(state=>state.cartslice.items);
    const dispatch = useDispatch();
    const [orderPlaced, setOrderPlaced] = useState(false);

    if(items.length === 0){
        return (
            <div className="w-[80%] mx-auto mt-20 text-center">
                <p className="font-display text-3xl font-semibold mb-6 text-charcoal">Your cart is empty</p>
                <Link to="/restaurant" className="text-xl text-ember underline">Browse restaurants</Link>
            </div>
        )
    }

    const total = items.reduce((sum, item) => sum + getItemPrice(item) * item.quantity, 0);

    return(
        <div className="w-[80%] mx-auto mt-20 mb-20">
            <h1 className="font-display text-4xl font-semibold mb-8 text-charcoal">Checkout</h1>

            {
                items.map(item => (
                    <div key={item.id} className="flex justify-between items-center py-4 border-b border-charcoal/15">
                        <div>
                            <p className="text-2xl font-semibold text-charcoal">{item.name}</p>
                            <p className="text-lg font-mono text-charcoal/60">₹{getItemPrice(item)} x {item.quantity}</p>
                        </div>
                        <div className="flex items-center gap-6">
                            <div className="flex items-center gap-3 text-xl text-ember border border-charcoal/15 rounded-xl px-4 py-2">
                                <button onClick={()=>dispatch(DecrementItems(item))}>-</button>
                                <span className="font-mono">{item.quantity}</span>
                                <button onClick={()=>dispatch(IncrementItems(item))}>+</button>
                            </div>
                            <p className="text-2xl font-mono font-semibold w-24 text-right text-charcoal">₹{(getItemPrice(item) * item.quantity).toFixed(2)}</p>
                        </div>
                    </div>
                ))
            }

            <div className="flex justify-between items-center mt-8 pt-6 border-t-2 border-charcoal/20">
                <p className="font-display text-3xl font-semibold text-charcoal">Total</p>
                <p className="font-mono text-3xl font-semibold text-charcoal">₹{total.toFixed(2)}</p>
            </div>

            {
                orderPlaced &&
                <p className="text-center text-2xl font-semibold text-curry mt-6">Order placed!</p>
            }

            <button
                className="w-full mt-10 py-4 text-2xl font-medium text-cream bg-ember rounded-2xl hover:brightness-110 transition disabled:opacity-60"
                onClick={()=>setOrderPlaced(true)}
                disabled={orderPlaced}
            >
                {orderPlaced ? "Order Placed" : "Place Order"}
            </button>
        </div>
    )
}
